module.exports = __webpack_public_path__ + "assets/custom-asset-icon.6962f61a.svg";